import spinModel from "../../model/SpinModel";
import { ICondition } from "../State";

export class HasWinCondition implements ICondition {
    public check(): boolean {
        return spinModel.hasWinnings();
    }
}